
export default function Logo( props ) {
	return <div style={ props.style }>
	    <div className="carat" >
			CARAT80
	    </div>
	    <div className="superyacht" >
			SUPERYACHT
	    </div>
	    <div className="cruises" >
			CRUISES
	    </div>
	</div>
}
